import { Pipe, PipeTransform } from '@angular/core';
import { Multilingual } from '@core/utilities/multilingual';

@Pipe({
  name: 'lang'
})
export class LanguagePipe implements PipeTransform {

  transform(value: string, language?: string): string {    
    return Multilingual.getText(value, language);
  }
}

